import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const BUNDLING_TOOLKIT_AND_CERTIFICATES_I18N_NAMESPACE =
  '@mc/checkout/experiments/prcng-698_v1'

export const i18nInstance = registerI18nResources({
  namespace: BUNDLING_TOOLKIT_AND_CERTIFICATES_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
